import type { PassportDetail } from '@/types/api';
import type { ApprovalAttributes } from '@/types/approval';
import { formatAsDate } from '@/utils/format';

/** 차량유지비 신청 — 레거시 appr_edit_forms_request_car_cost */
export const VEHICLE_COST_TYPE = 93;

export const isVehicleCostType = (apvType: number): boolean =>
  apvType === VEHICLE_COST_TYPE;

export const VEHICLE_COST_HR_MISSING_MESSAGE =
  '[알림] 인사 정보가 등록되지 않았습니다. 인사 정보 등록 후 품의 작성 가능합니다. HR팀으로 문의하시기 바랍니다.';

export type VehicleCostEmployee = {
  name: string;
  employeeNumber: string;
  /** 법인·사업부·부서를 공백으로 이은 값 */
  affiliation: string;
  enterDate: string;
};

type EmployeeSource = Pick<
  PassportDetail,
  | 'name'
  | 'employeeNumber'
  | 'companyName'
  | 'divisionName'
  | 'departmentName'
  | 'joinedAt'
>;

/** 사번이 없으면 인사 정보 미등록으로 보고 null */
export const toVehicleCostEmployee = (
  info: EmployeeSource | null | undefined,
): VehicleCostEmployee | null => {
  if (!info?.employeeNumber) return null;
  return {
    name: info.name ?? '',
    employeeNumber: info.employeeNumber,
    affiliation: [info.companyName, info.divisionName, info.departmentName]
      .filter(Boolean)
      .join(' '),
    enterDate: info.joinedAt ? formatAsDate(info.joinedAt) : '',
  };
};

/** 저장 attributes.content. 없거나 빈 문자열이면 null */
export const parseVehicleCostContent = (attributes: unknown): string | null => {
  if (!attributes || typeof attributes !== 'object') return null;
  const raw = (attributes as Record<string, unknown>).content;
  return typeof raw === 'string' && raw.trim() ? raw : null;
};

export const checkVehicleCostBeforeSave = (
  content: string | null | undefined,
): string | null => (content ? null : VEHICLE_COST_HR_MISSING_MESSAGE);

export const buildVehicleCostAttributes = (
  content: string | null | undefined,
): ApprovalAttributes | null => (content ? { content } : null);
